import React from 'react';

const ActionToolbar = ({ className = '', align = 'left', tone = 'default', children }) => {
  const alignClass = align === 'right' ? 'justify-end' : 'justify-start';
  const toneClass = tone === 'hero'
    ? 'gap-1.5 rounded-xl border border-white/45 bg-white/20 px-2 py-1.5 shadow-lg backdrop-blur-md'
    : 'gap-2';

  return (
    <div className={`flex items-center ${alignClass} ${toneClass} ${className}`.trim()}>
      {children}
    </div>
  );
};

export default ActionToolbar;
